import { getBirthdayCouponsDetails } from "../api/BirthdayCouponsApi";
import { PlayOrPauseAllBirthdayCoupon } from "../api/BirthdayCouponsApi";
import { errorMessage, successMessage } from "../../../utils";
import { useEffect } from "react";
import { useImmer } from "use-immer";

export const useBirthdayCouponsV2 = () => {
  const [state, setState] = useImmer({
    isLoading: true,
    couponData: null,
    isSaveButtonBusy: false,
    statusModalOpen: false,
    statusModalType: null,
  });
  const handleBirthdayCouponDetails = async () => {
    try {
      const res = await getBirthdayCouponsDetails();
      if (res.success) {
        setState((draft) => {
          draft.couponData = res.data;
          draft.isLoading = false;
        });
      } else {
        setState((draft) => {
          draft.isLoading = false;
        });
        errorMessage(res.message);
      }
    } catch (err) {
      errorMessage(err.response.data.message);
    }
  };

  const handleStatusModal = (type, isOpen) => {
    setState((draft) => {
      draft.statusModalOpen = isOpen;
      draft.statusModalType = isOpen ? type : null;
    });
  };

  const handlePlayPauseStatus = async () => {
    try {
      setState((draft) => {
        draft.isSaveButtonBusy = true;
      });

      const res = await PlayOrPauseAllBirthdayCoupon(state.couponData.id);
      if (res.success) {
        successMessage(res.message);
        setState((draft) => {
          draft.isSaveButtonBusy = false;
          draft.couponData.active = draft.couponData.active === 2 ? 3 : 2;
        });
      }
    } catch (err) {
      errorMessage(err.response?.data?.message || "Failed to change status");
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });
    }
  };

  useEffect(() => {
    handleBirthdayCouponDetails();
  }, []);

  return {
    state,
    setState,
    handlePlayPauseStatus,
    handleStatusModal,
  };
};
